function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isNumber from 'lodash/isNumber';
import { EventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { AllhomesSearchListingCard, MultipleListingCard } from '@domain-group/fe-co-allhomes-listing-card';
import * as styles from './popup-window.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class PopupWindow extends Component {
  componentDidMount() {
    this.props.onRender(this.getContainer().getBoundingClientRect());
  }
  getContainer() {
    return this._container;
  }
  getEventData(listing, position) {
    var _listing$listing;
    return {
      address: listing.address,
      property: listing.property,
      price: (_listing$listing = listing.listing) === null || _listing$listing === void 0 ? void 0 : _listing$listing.priceLabel,
      position: isNumber(position) ? position + 1 : undefined,
      listingCategory: this.props.listingCategory,
      badges: listing.badges
    };
  }
  renderMultipleCards() {
    return this.props.listings.map((item, index) => ___EmotionJSX(EventBoundary, {
      name: "popup-window",
      data: this.getEventData(item, index)
    }, ___EmotionJSX(MultipleListingCard, _extends({
      key: "popup-".concat(item.listing.id)
    }, item, {
      onAddToWatchlist: this.props.onAddToWatchlist,
      scrollableParent: this.props.listings.length >= 3,
      onClick: this.props.onListingClick
    }))));
  }
  render() {
    var multipleClasses = {
      isMultiple2: this.props.listings.length === 2,
      isMultiple3Plus: this.props.listings.length >= 3
    };
    var listingsWithInspections = 0;
    this.props.listings.forEach(item => {
      if (listingsWithInspections < 2 && Boolean(item.listing.nextInspection && item.listing.nextInspection.startdate)) {
        listingsWithInspections += 1;
      }
    });
    if (listingsWithInspections > 0) {
      multipleClasses["hasInspection".concat(listingsWithInspections)] = true;
    }
    return ___EmotionJSX("div", {
      css: styles.popup(multipleClasses),
      ref: container => {
        this._container = container;
      },
      onMouseEnter: this.props.onMouseEnter,
      onMouseLeave: this.props.onMouseLeave
    }, ___EmotionJSX("div", {
      css: styles.popupListings(multipleClasses)
    }, this.props.listings.length === 1 && ___EmotionJSX(EventBoundary, {
      name: "popup-window",
      data: this.getEventData(this.props.listings[0])
    }, ___EmotionJSX(AllhomesSearchListingCard, _extends({}, this.props.listings[0], {
      appearance: "vertical",
      onAddToWatchlist: this.props.onAddToWatchlist,
      openInNewTab: true
    }))), this.props.listings.length > 1 && this.renderMultipleCards()));
  }
}
PopupWindow.propTypes = {
  onAddToWatchlist: PropTypes.func,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  onListingClick: PropTypes.func,
  listings: PropTypes.array,
  // eslint-disable-line react/forbid-prop-types
  onRender: PropTypes.func,
  listingCategory: PropTypes.string
};
PopupWindow.defaultProps = {
  listings: [],
  onAddToWatchlist: () => {},
  onRender: () => {},
  onListingClick: () => {},
  listingCategory: ''
};
export default PopupWindow;